import { getAPIFromDomain } from "../../lib/api";

export interface FetchEventSubscriptionsQuery {
  per_page?: number;
  page?: number;
  organization_id?: string;
}

export const fetchEventSubscriptionsIndex = async (query: FetchEventSubscriptionsQuery): Promise<any> => {
  const api = getAPIFromDomain("accounts");
  const url = "/event_subscriptions";
  const res = await api.get(url, { params: { ...query } });
  return res.data;
};
